import React from 'react';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';

import { Input } from 'widget/components';

interface Name {
  style: React.CSSProperties;
}

const Name = ({ style }: Name) => {
  const [field, meta, helpers] = useField<string>('name');
  const { t } = useTranslation();

  const isValid = !(meta.error && meta.touched);

  return (
    <Input
      {...field}
      isValid={isValid}
      onChange={helpers.setValue}
      placeholder={t`Your name`}
      style={style}
    />
  );
};

export default Name;
